/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * What happens to existing observability plugin hooks keys after the replacement is minted.
 */
export const PreviousKeyFate = {
  RevokeImmediately: "revoke_immediately",
  Grace: "grace",
} as const;
/**
 * What happens to existing observability plugin hooks keys after the replacement is minted.
 */
export type PreviousKeyFate = ClosedEnum<typeof PreviousKeyFate>;

export type RotateObservabilityCredentialRequestBody = {
  /**
   * What happens to existing observability plugin hooks keys after the replacement is minted.
   */
  previousKeyFate: PreviousKeyFate;
};

/** @internal */
export const PreviousKeyFate$outboundSchema: z.ZodMiniEnum<
  typeof PreviousKeyFate
> = z.enum(PreviousKeyFate);

/** @internal */
export type RotateObservabilityCredentialRequestBody$Outbound = {
  previous_key_fate: string;
};

/** @internal */
export const RotateObservabilityCredentialRequestBody$outboundSchema:
  z.ZodMiniType<
    RotateObservabilityCredentialRequestBody$Outbound,
    RotateObservabilityCredentialRequestBody
  > = z.pipe(
    z.object({
      previousKeyFate: PreviousKeyFate$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        previousKeyFate: "previous_key_fate",
      });
    }),
  );

export function rotateObservabilityCredentialRequestBodyToJSON(
  rotateObservabilityCredentialRequestBody:
    RotateObservabilityCredentialRequestBody,
): string {
  return JSON.stringify(
    RotateObservabilityCredentialRequestBody$outboundSchema.parse(
      rotateObservabilityCredentialRequestBody,
    ),
  );
}
